import store from '../store'
import ProgramRoles from '../mixins/ProgramRoles'

export default function intercom() {

  const keycloak = store.state.auth.keycloak
  const userRole = store.state.platformProgram.activeOrganization.active_role || ''
  const firstHostName = window.location.hostname.split('.')[0]
  const secondHostName = window.location.hostname.split('.')[1]
  const programId = secondHostName === 'play' || (firstHostName !== 'play' && secondHostName === 'plataformaidt') ? firstHostName : 'minha-conta'

  /*global Intercom*/
  /*eslint no-undef: "error"*/
  Intercom("boot", {
    app_id: "w0hz6ask",
    email: keycloak.tokenParsed.email,
    name: keycloak.tokenParsed.name,
    product: "platform-idt",
    user_id: keycloak.tokenParsed.preferred_username,
    user_role: userRole,
    program_id: programId,
    widget: {
      activator: "#IntercomDefaultWidget"
    }
  })

  window.clarity('identify', keycloak.tokenParsed.email, userRole, programId, keycloak.tokenParsed.email)
  window.clarity('set', 'user_role', userRole)
  window.clarity('set', 'user_email', keycloak.tokenParsed.email)

  if(programId !== 'minha-conta'){
    window.clarity('set', 'user_program', programId)
  }

  window.hj('identify', keycloak.tokenParsed.preferred_username, {
    user_role: userRole
  });
}
